"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26.6666 10.6667H22.6666V5.33337H3.99998C2.53331 5.33337 1.33331 6.53337 1.33331 8.00004V22.6667H3.99998C3.99998 24.88 5.78665 26.6667 7.99998 26.6667C10.2133 26.6667 12 24.88 12 22.6667H20C20 24.88 21.7866 26.6667 24 26.6667C26.2133 26.6667 28 24.88 28 22.6667H30.6666V16L26.6666 10.6667ZM26 12.6667L28.6133 16H22.6666V12.6667H26ZM7.99998 24C7.26665 24 6.66665 23.4 6.66665 22.6667C6.66665 21.9334 7.26665 21.3334 7.99998 21.3334C8.73331 21.3334 9.33331 21.9334 9.33331 22.6667C9.33331 23.4 8.73331 24 7.99998 24ZM10.96 20C10.2266 19.1867 9.18665 18.6667 7.99998 18.6667C6.81331 18.6667 5.77331 19.1867 5.03998 20H3.99998V8.00004H20V20H10.96ZM24 24C23.2666 24 22.6666 23.4 22.6666 22.6667C22.6666 21.9334 23.2666 21.3334 24 21.3334C24.7333 21.3334 25.3333 21.9334 25.3333 22.6667C25.3333 23.4 24.7333 24 24 24Z"
})), 'DeliveryDefault', {
  viewBox: '0 0 16 16'
});

exports.default = _default;